<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            USUÁRIO -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-detalhe titulo="Nome" :size="size">
                            <strong>{{ usuario.nome }}</strong>
                        </app-detalhe>
                        <app-detalhe titulo="Login" :size="size">
                            <strong>{{ usuario.login }}</strong>
                        </app-detalhe>
                        <app-detalhe titulo="Email" :size="size">
                            <strong>{{ usuario.email }}</strong>
                        </app-detalhe>
                        <app-detalhe titulo="Status" :size="size">
                            <app-status
                                :status="
                                    usuario.statusDescr
                                        ? usuario.statusDescr
                                        : ''
                                "
                            ></app-status>
                        </app-detalhe>
                        <app-detalhe titulo="Última Atualização" :size="size">
                            <strong>{{
                                usuario.dataAtualizacao
                                    ? $moment(usuario.dataAtualizacao).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : ''
                            }}</strong>
                        </app-detalhe>
                    </b-card-body>
                    <b-card-footer>
                        <app-usuario-ativar-desativar
                            :usuario="usuario"
                            @obterUsuario="obterUsuario()"
                        ></app-usuario-ativar-desativar>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-tabs pills card vertical>
                        <b-tab title="Perfis de Acesso" active class="pb-0">
                            <app-usuario-perfis-acesso
                                v-if="$temAcessoView('CTRLACS-USR-06-01')"
                                :usuario="usuario"
                                @obterUsuario="obterUsuario()"
                            ></app-usuario-perfis-acesso>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'
import UsuarioPerfisAcesso from './UsuarioPerfisAcesso'
import UsuarioResetarSenha from './UsuarioResetarSenha'
import UsuarioAtivarDesativar from './UsuarioAtivarDesativar'

export default {
    data() {
        return {
            usuario: {},
            size: '120'
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Usuarios' })
        },

        obterUsuario() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterPorId(this.$route.params.usuarioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.usuario = response.data
                            this.usuario.telefone = this.$mask(
                                this.usuario.telefone,
                                ['(##) ####-####', '(##) #####-####']
                            )
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        transferirParaAtualizacao() {
            this.$router.push({
                name: 'Usuarios_Atualizar',
                params: { usuarioId: this.$route.params.usuarioId }
            })
        },

        processarRota(rota) {
            if (rota.name === 'Usuarios_Detalhar') {
                this.operacao = 'DETALHAR'
                this.obterUsuario()
            }
        }
    },

    computed: {
        mostrarBtnAtualizar() {
            return this.$temAcessoView('CTRLACS-USR-03')
        }
    },

    created() {
        this.processarRota(this.$route)
    },

    components: {
        AppUsuarioPerfisAcesso: UsuarioPerfisAcesso,
        AppUsuarioResetarSenha: UsuarioResetarSenha,
        AppUsuarioAtivarDesativar: UsuarioAtivarDesativar
    }
}
</script>
